import { Component } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-set-report-password-required-dialog',
  templateUrl: './set-report-password-required-dialog.component.html',
  styleUrls: ['./set-report-password-required-dialog.component.scss'],
})
export class SetReportPasswordRequiredDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<SetReportPasswordRequiredDialogComponent>,
    private readonly router: Router
  ) {}

  cancel(): void {
    this.dialogRef.close();
  }

  goToProfile(): void {
    this.router.navigate(['/profile/details']);
    this.dialogRef.close();
  }
}
